module.exports = __webpack_public_path__ + "d478013924a591d5923aefbcb8e964fd.svg";